import { Controller } from "@hotwired/stimulus"
import { enter, leave, toggle } from "el-transition"

// Button 	-> Enabled: "bg-highlight", Not Enabled: "bg-gray-200"
// Span 	-> Enabled: "translate-x-6", Not Enabled: "translate-x-0"

// Connects to data-controller="onoffswitch"
export default class extends Controller {
	static targets = ["button", "span", "checkbox", "optionen"]
	connect() {
		// Optionen falls vorhanden auf initialen Status setzen
		if (this.hasOptionenTarget && this.hasCheckboxTarget && this.checkboxTarget.checked) {
			this.optionenTarget.classList.remove("grid-rows-[0fr]")
			this.optionenTarget.classList.add("grid-rows-[1fr]")
			this.optionenTarget.classList.remove("hidden")
		}
	}

	toggle() {
		// Toggle Checkbox Value
		if (this.hasCheckboxTarget) this.checkboxTarget.checked = !this.checkboxTarget.checked
		this.checkboxTarget.dispatchEvent(new Event("change"))

		// Toggle Form Element
		this.toggleFormElement()
		// Toggle Optionen
		if (this.hasOptionenTarget) {
			toggle(this.optionenTarget).then(() => {
				// Setzt den Focus auf das erste Eingabe-Element in den Switcher Options wenn Switcher aktiviert wird
				if (this.hasCheckboxTarget && this.checkboxTarget.checked) this.focusFirstOptionElement()
			})
		}
	}

	// Private Methods

	toggleFormElement() {
		if (!this.hasButtonTarget || !this.hasSpanTarget) return

		this.buttonTarget.classList.toggle("bg-gray-200")
		this.buttonTarget.classList.toggle("bg-highlight")

		this.spanTarget.classList.toggle("translate-x-0")
		this.spanTarget.classList.toggle("translate-x-6")
	}

	focusFirstOptionElement() {
		const firstOptionElement = this.optionenTarget.querySelector("select, input[type=text]")
		if (firstOptionElement) firstOptionElement.focus()
	}
}
